import { UserAction } from '@api/userActionsApiHandler';
import { useAppSelector } from '@hooks/useAppSelector';
import { MotionText } from '@shared/atoms';
import { NoDataBlueTraySection, SystemButton } from '@shared/molecules';
import { ActionCard } from '@shared/organisms/Plans/ActionCard/ActionCard';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import styles from './styles.module.scss';

interface InsightsSectionProps {
  userActions: UserAction[] | [];
  refetchActions: () => void;
}

export const ActionsSection: React.FC<InsightsSectionProps> = ({ userActions, refetchActions }) => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const questionnaireId = params.get('questionnaireId');
  const { chartSelectedAssessment } = useAppSelector((state) => state.assessmentScores || {});

  return (
    <div className={styles.actionsContainer}>
      <div className={styles.topContainer}>
        <MotionText
          id="actions-heading"
          as="h3"
          text="Recommended next actions"
          className={styles.sectionTitle}
        />
      </div>

      <MotionText
        id="priorities-heading"
        as="text"
        text="We’ve created a personalised plan of suggested actions and activities. These recommendations
            aim to support and improve your wellbeing."
        className={styles.sectionDescription}
      />

      <div className={styles.actionSection}>
        {userActions.length > 0 ? (
          userActions.map((item: UserAction, index: number) => {
            const dueDate =
              item.dueDays >= 0
                ? `${Math.abs(item.dueDays)} days to go`
                : `${Math.abs(item.dueDays)} days overdue`;

            const overdue = item.dueDays < 0;

            return (
              <ActionCard
                key={index}
                actionData={item}
                className={`${styles.actionCard} ${styles.calmLilac}`}
                title={item.title || ''}
                description={item.description || ''}
                dueDate={dueDate}
                completed={item.completed !== null}
                overdue={overdue}
                theme="#beaaf3"
                actionButtonName={item.actionButtonTitle}
                actionImage={item.actionImage}
                handleRefetch={refetchActions}
                isDashboardAction
              />
            );
          })
        ) : (
          <NoDataBlueTraySection text="No active actions found." />
        )}
      </div>

      {userActions.length > 0 && (
        <div className={styles.viewActionsButton}>
          <SystemButton onClick={() => history.push('/improve-plans')}>
            &nbsp;&nbsp;&nbsp;View Your Plan&nbsp;&nbsp;&nbsp;
          </SystemButton>
        </div>
      )}
    </div>
  );
};
